import * as THREE from 'three'
import { OrbitControls } from '/node_modules/three/examples/jsm/controls/OrbitControls'
import { log } from 'three/tsl'
// import DeckSize from '../../DeckSideBar/DeckSize.jsx'

// Intialization scene,camera,plane,renderer
export function createSceneAndLight() {
  let scene = new THREE.Scene()
  scene.background = new THREE.Color(0xf8fafc)

  const light = new THREE.AmbientLight(0xffffbb, 0x080820, 1)
  light.position.set(30, 30, 30).normalize()
  scene.add(light)
  return scene
}

export function createAndAddingGroups() {
  let cargo_area_group = new THREE.Group()
  cargo_area_group.name = 'cargo_area_group'
  
  let cargo_group = new THREE.Group()
  cargo_group.name = 'cargo_group'
  
  let group_of_cargo_area_floor = new THREE.Group()
  group_of_cargo_area_floor.name = 'group_of_cargo_area_floor'
  
  let group_of_cargo_area_attribute = new THREE.Group()
  group_of_cargo_area_attribute.name = 'group_of_cargo_area_attribute'

  return [
    cargo_area_group,
    cargo_group,
    group_of_cargo_area_floor,
    group_of_cargo_area_attribute,
  ]
}


export function createCamera(cargoArea) {
  let camera = new THREE.PerspectiveCamera(
    75,
    window.innerWidth / window.innerHeight,
    0.1,
    100000
  )

  let maxPosition = 1200;
  
  if (Array.isArray(cargoArea) && cargoArea.length > 0) {
    const firstItem = cargoArea[0];
    
    if (firstItem && typeof firstItem === 'object') {
      const { widthX, heightY, depthZ } = firstItem;
      maxPosition = Math.max(
        widthX || 0,
        heightY || 0,
        depthZ || 0
      ) || 1200;
    }
  }

  camera.position.x = maxPosition * 1.2;
  camera.position.z = maxPosition * 1.2;
  camera.position.y = maxPosition * 1.2;
  
  return camera;
}

export function createRenderer() {
  let renderer = new THREE.WebGLRenderer()
  renderer.setSize(850, 600)
  return renderer
}

// Rotation camera with orbit controls.
export function createControls(camera, renderer) {
  let controls = new OrbitControls(camera, renderer.domElement)

  controls.enableDamping = true
  controls.dampingFactor = 0.1 // плавность при вращении
  controls.zoomSpeed = 0.5 // скорость приближения/отдаления
  controls.rotateSpeed = 0.5 // скорость вращения
  controls.panSpeed = 1 // скорость панорамирования (если включено)
  controls.enableZoom = true
  controls.enablePan = true

  return controls
}

// Arrow key camera movement function - ADD THIS EXPORT
export function setupArrowKeyScroll(camera, controls, renderer) {
  const handleKeyDown = (event) => {
    const scrollSpeed = 100; // Increased speed for better visibility
    const panSpeed = 100;
    
    switch(event.key) {
      case 'ArrowDown':
        if (event.shiftKey) {
          // Move camera backward
          camera.translateZ(scrollSpeed);
        } else {
          // Pan camera down
          controls.target.y -= panSpeed;
          camera.position.y -= panSpeed;
        }
        controls.update();
        event.preventDefault();
        break;
        
      case 'ArrowUp':
        if (event.shiftKey) {
          // Move camera forward
          camera.translateZ(-scrollSpeed);
        } else {
          // Pan camera up
          controls.target.y += panSpeed;
          camera.position.y += panSpeed;
        }
        controls.update();
        event.preventDefault();
        break;
        
      case 'ArrowLeft':
        if (event.shiftKey) {
          // Strafe left
          camera.translateX(-scrollSpeed);
        } else {
          // Pan camera left
          controls.target.x -= panSpeed;
          camera.position.x -= panSpeed;
        }
        controls.update();
        event.preventDefault();
        break;
        
      case 'ArrowRight':
        if (event.shiftKey) {
          // Strafe right
          camera.translateX(scrollSpeed);
        } else {
          // Pan camera right
          controls.target.x += panSpeed;
          camera.position.x += panSpeed;
        }
        controls.update();
        event.preventDefault();
        break;
        
      case 'w':
      case 'W':
        // Move forward
        camera.translateZ(-scrollSpeed);
        controls.update();
        event.preventDefault();
        break;
        
      case 's':
      case 'S':
        // Move backward
        camera.translateZ(scrollSpeed);
        controls.update();
        event.preventDefault();
        break;
        
      case 'a':
      case 'A':
        // Strafe left
        camera.translateX(-scrollSpeed);
        controls.update();
        event.preventDefault();
        break;
        
      case 'd':
      case 'D':
        // Strafe right
        camera.translateX(scrollSpeed);
        controls.update();
        event.preventDefault();
        break;
        
      case 'q':
      case 'Q':
        // Move up
        camera.position.y += scrollSpeed;
        controls.target.y += scrollSpeed;
        controls.update();
        event.preventDefault();
        break;
        
      case 'e':
      case 'E':
        // Move down
        camera.position.y -= scrollSpeed;
        controls.target.y -= scrollSpeed;
        controls.update();
        event.preventDefault();
        break;
        
      case 'r':
      case 'R':
        // Reset camera
        camera.position.set(7, 7, 7);
        controls.target.set(0, 0, 0);
        controls.update();
        event.preventDefault();
        break;
    }
  };

  // Add event listener to the renderer's DOM element
  renderer.domElement.addEventListener('keydown', handleKeyDown);
  
  // Return cleanup function
  return () => {
    renderer.domElement.removeEventListener('keydown', handleKeyDown);
  };
}

export function clearScene(sce) {
  // Проходим по всем объектам в сцене и очищаем их
  if (!sce) {
    return
  }
  sce.traverse((object) => {
    if (object instanceof THREE.Mesh) {
      // Очищаем геометрию
      if (object.geometry) {
        object.geometry.dispose()
      }
      // Очищаем материалы
      if (object.material) {
        // Если материал имеет текстуру, очищаем её
        if (object.material.map) {
          object.material.map.dispose()
        }
        object.material.dispose()
      }
    }

    if (object instanceof THREE.Light) {
      // Если объект - свет, очищаем его ресурсы
      if (object.isPointLight || object.isDirectionalLight) {
        // Пример для точечных и направленных источников света
        if (object.shadow) {
          object.shadow.dispose()
        }
      }
    }

    if (object instanceof THREE.Texture) {
      // Если объект является текстурой
      object.dispose()
    }
  })

  // Очистка всей сцены
  sce.clear()
}